import React, { useMemo, useRef } from 'react'
import { Box, Collapse, makeStyles, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import { useTranslation } from 'next-i18next'
import { orderStatusToTextMap, orderStatusToTextMapEng } from '../utility/trackingUtility'

const useStyles = makeStyles((theme) => ({
    root: {
        border: '2px solid #f0f0f0',
        borderRadius: '5px',
        
        padding: '10px',
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',

        padding: '20px 0',

        cursor: 'pointer',
    },
    label: {
        display: 'flex',

        '& > p': {
            marginLeft: '5px',
        }
    },
    title: {
        fontSize: '14px',

        '& > span': {
            color: theme.palette.primary.main,
        }
    },
    content: {
        borderTop: '2px solid #f0f0f0',

        padding: '0 130px',

        [theme.breakpoints.down('md')]: {
            padding: '0',
        }
    }
}))

const CollapseCard = ({ trackindId, status, children, handleOpen, open, isOpen = false }) => {
    const classes = useStyles()
    const _open = open === trackindId || isOpen
    const cardRef = useRef(null)

    const { t, i18n } = useTranslation('tracking')
    const selectMap = i18n.language === 'th' ? orderStatusToTextMap : orderStatusToTextMapEng

    const statusColor = useMemo(() => {
        switch (orderStatusToTextMapEng[status]) {
            case orderStatusToTextMapEng.complete: {
                return '#219653'
            }
            case orderStatusToTextMapEng.shipping: {
                return '#F2994A'
            }
            case orderStatusToTextMapEng.booking: {
                return '#11CDEF'
            }
            case orderStatusToTextMapEng.cancel: {
                return '#EB5757'
            }
            default:
                return '#333'
        }
    }, [status])

    const originalOffset = useMemo(() => {
        return cardRef.current && cardRef.current.offsetTop
    }, [cardRef.current])
    
    return (
        <Box className={classes.root} ref={cardRef}>
            <Box 
                className={classes.titleContainer}
                onClick={() => handleOpen(trackindId, originalOffset)} 
            >
               <Box className={classes.label}>
                <Typography className={classes.title}>{t('parcel-code')} <span>{trackindId}</span></Typography>
                <Typography className={classes.title}>{t('parcel-status')} <span style={{ color: statusColor }}>{selectMap[status]}</span></Typography>
               </Box>

                {_open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>
            <Collapse in={_open}>
                <Box className={classes.content}>
                    {children}
                </Box>
            </Collapse>
        </Box>
    )
}

export default CollapseCard